export default __webpack_public_path__ + "static/media/ic-payment.0642dbba.svg";